type ElementAttributes = Record<string, string>;

interface CreateElementOptions {
  className?: string;
  attributes?: ElementAttributes;
  text?: string;
  html?: string;
  children?: Node[];
  style?: Partial<CSSStyleDeclaration>;
}

/**
 * Typisierte Element-Erstellung als jQuery $('<div>') Ersatz
 */
export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  options?: CreateElementOptions
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);

  if (options?.className) el.className = options.className;
  if (options?.text) el.textContent = options.text;
  if (options?.html) el.innerHTML = options.html;

  if (options?.attributes) {
    for (const [key, value] of Object.entries(options.attributes)) {
      el.setAttribute(key, value);
    }
  }

  if (options?.style) {
    Object.assign(el.style, options.style);
  }

  if (options?.children) {
    options.children.forEach(child => el.appendChild(child));
  }

  return el;
}

/**
 * Kurzform für häufige Patterns
 */
export function div(options?: CreateElementOptions): HTMLDivElement {
  return createElement('div', options);
}

export function span(options?: CreateElementOptions): HTMLSpanElement {
  return createElement('span', options);
}

export function button(options?: CreateElementOptions): HTMLButtonElement {
  return createElement('button', options);
}

export function input(options?: CreateElementOptions): HTMLInputElement {
  return createElement('input', options);
}

export function label(options?: CreateElementOptions): HTMLLabelElement {
  return createElement('label', options);
}

export function anchor(options?: CreateElementOptions): HTMLAnchorElement {
  return createElement('a', options);
}

export function img(options?: CreateElementOptions): HTMLImageElement {
  return createElement('img', options);
}
